import React from 'react'
import { Text } from '@vtex/admin-ui'
import type { TextProps } from '@vtex/admin-ui'

export type IndicatorCardTitleProps = TextProps

export const IndicatorCardTitle = ({
  className,
  ...props
}: IndicatorCardTitleProps) => <Text variant="title1" {...props} />
